// Import Redux Types
import {
  DOWNLOAD_CREATOR_OFFERING_DATA,
  SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA,
  ERROR_DOWNLOAD_CREATOR_OFFERING_DATA,
  SEND_OFFERING,
  SUCCESS_SEND_OFFERING,
  ERROR_SEND_OFFERING,
  UPDATE_TEMPORAL_IMAGE,
  UPDATE_CONFIRMED_IMAGE,
  SHOW_CUTTER_IMAGE
} from '../types/index'
// Import Services
import { get, post } from './../services/api'
// Import Actions
import { showLoaderAction } from './generalAction'
import { setDataModalAction, openModalAction } from './modalAction'
import { downloadCurrentOfferingAction } from './offeringsAction'

//import { toCreateOfferingSubmit } from './datalayer'


// Function
export function downloadCreatorOfferingAction() {
  return async ( dispatch:any ) => {
    dispatch( downloadCreatorOffering() )
    try {
      const response = await get('d3d1c4t0r1a')
			dispatch( successDownloadCreatorOffering( response ) )
    } catch(error) {
      dispatch( errorDownloadCreatorOffering() )
    }
  }
}
const downloadCreatorOffering = () => ({
  type: DOWNLOAD_CREATOR_OFFERING_DATA
})
const successDownloadCreatorOffering = (data:any) => ({
  type: SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA,
  payload: data
})
const errorDownloadCreatorOffering = () => ({
  type: ERROR_DOWNLOAD_CREATOR_OFFERING_DATA
})


export function sendOfferingAction( dataForm:any ) {
  return async ( dispatch:any ) => {

    // const imageFile = dataForm.get('offeringPhoto')
    // const imageUrl = URL.createObjectURL(imageFile)

    dispatch( showLoaderAction( true ) )
    dispatch( sendOffering() )
    try {
      //toCreateOfferingSubmit()
      // const response:any = await post('0ff3r1ng', dataForm, false, false)
      const response:any = await post('0ff3r1ng', dataForm, false)
      if( response.status === 'ok' ) {
        dispatch( setDataModalAction('success', {
          hasClose: false,
          title: '¡TU DEDICATORIA FUE CREADA!',
          text: 'CON ESTA OFRENDA ESTÁS PARTICIPANDO EN EL SORTEO DE UN SIX DE LATAS PERSONALIZADAS.',
          btn: {
            text: 'Volver al inicio',
            link: '/'
          },
          photo: dataForm.offeringPhoto,
          downloadBtn: true,
          shareBtn: true
        }) )
        dispatch( openModalAction('success') )
      }
      if( response.id ) dispatch( downloadCurrentOfferingAction( response.id ) )
      if( response.status === 'auth' ) {
        dispatch( setDataModalAction('message', {
          hasClose: true,
          title: 'Error de autenticación',
          text: 'Debes registrarte para crear tu ofrenda',
          btn: {
            text: 'Ir al registro',
            link: '/registro'
          }
        }) )
        dispatch( openModalAction('message') )
      }
      if( response.status === 'error' ) {
        dispatch( setDataModalAction('message', {
          hasClose: true,
          title: 'Error de autenticación',
          text: 'Lo sentimos! en este momento no puedes crear una ofrenda. Inténtalo de nuevo.',
          btn: {
            text: 'Recargar',
            link: '[reload]'
          }
        }) )
        dispatch( openModalAction('message') )
      }
      if( response.status === 'registered' ) {
        dispatch( setDataModalAction('message', {
          hasClose: true,
          title: 'Lo sentimos',
          text: 'ya estÁs participando en el sorteo de seis latas con tu dedicatoria. te invitamos a ver otras ofrendas.',
          btn: {
            text: 'ver ofrendas',
            link: '/cempasuchil/ofrendas-vivas'
          }
        }) )
        dispatch( openModalAction('message') )
      }
			dispatch( successSendOffering( response ) )
    } catch(error) {
      dispatch( errorSendOffering() )
    } finally {
      dispatch( showLoaderAction( false ) )
    }
  }
}
const sendOffering = () => ({
  type: SEND_OFFERING
})
const successSendOffering = (data:any) => ({
  type: SUCCESS_SEND_OFFERING,
  payload: data
})
const errorSendOffering = () => ({
  type: ERROR_SEND_OFFERING
})


export function updateTemporalImageAction( dataImg:{} ) {
  return async ( dispatch:any ) => {
    dispatch( updateTemporalImage( dataImg ) )
  }
}
const updateTemporalImage = ( dataImg:{} ) => ({
  type: UPDATE_TEMPORAL_IMAGE,
  payload: dataImg
})


export function updateConfirmedImageAction( dataImg:{} ) {
  return async ( dispatch:any ) => {
    dispatch( updateConfirmedImage( dataImg ) )
  }
}
const updateConfirmedImage = ( dataImg:{} ) => ({
  type: UPDATE_CONFIRMED_IMAGE,
  payload: dataImg
})


export function showCutterImageAction( willBeVisible:boolean ) {
  return async ( dispatch:any ) => {
    dispatch( showCutterImage( willBeVisible ) )
  }
}
const showCutterImage = ( willBeVisible:boolean ) => ({
  type: SHOW_CUTTER_IMAGE,
  payload: willBeVisible
})
